var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('h3',{staticClass:"border-bottom"},[_vm._v("Acessos à Sala")]),_c('RegistrosList',{attrs:{"temposTotais":_vm.tempos_totais,"registros":_vm.registrosSala}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }